import { Box, Tooltip, IconButton, Modal, Backdrop, Fade } from "@mui/material";
import {
    FaRegCopy,
    FaCheck,
    FaDownload,
    FaWhatsapp,
    FaFacebookF,
} from "react-icons/fa";
import ShareLinkRow from "./ShareLinkRow";
import { useState } from "react";
import QRCode from "react-qr-code";

export default function ShareModal({ open, setOpen, shareLink }) {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(shareLink);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const handleShare = (platform) => {
        let url = "";
        const encodedLink = encodeURIComponent(shareLink);

        switch (platform) {
            case "whatsapp":
                url = `https://wa.me/?text=${encodedLink}`;
                break;

            case "facebook":
                url = `https://www.facebook.com/sharer/sharer.php?u=${encodedLink}`;
                break;

            default:
                break;
        }

        window.open(url, "_blank");
    };

    const downloadQR = () => {
        const svg = document.getElementById("qr-code");
        if (!svg) return;

        const serializer = new XMLSerializer();
        const svgStr = serializer.serializeToString(svg);

        const canvas = document.createElement("canvas");
        const size = 250;
        canvas.width = size;
        canvas.height = size;

        const ctx = canvas.getContext("2d");
        if (!ctx) return;

        const img = new Image();
        img.onload = () => {
            ctx.fillStyle = "#ffffff";
            ctx.fillRect(0, 0, size, size);
            const x = (size - img.width) / 2;
            const y = (size - img.height) / 2;

            ctx.drawImage(img, x, y);

            const pngFile = canvas.toDataURL("image/png");

            const link = document.createElement("a");
            link.download = "pin-bilalabdulhadi-com.png";
            link.href = pngFile;
            link.click();
        };

        img.src =
            "data:image/svg+xml;base64," +
            btoa(unescape(encodeURIComponent(svgStr)));
    };

    return (
        <Modal
            open={open}
            onClose={() => setOpen(false)}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                    sx: {
                        backdropFilter: "blur(6px)",
                        backgroundColor: "rgba(0,0,0,0.3)",
                    },
                },
            }}
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}>
            <Fade in={open}>
                <Box
                    sx={{
                        width: { xs: "90%", sm: 400 },
                        background: "rgba(255,255,255,0.85)",
                        borderRadius: 3,
                        p: 3,
                        boxShadow: "0 20px 50px rgba(0,0,0,0.2)",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 2,
                        maxHeight: "90vh",
                        overflowY: "auto",
                        transform: open ? "scale(1)" : "scale(0.9)",
                        transition: "transform 0.3s ease, opacity 0.3s ease",
                    }}>
                    <Box
                        sx={{
                            width: 250,
                            height: 250,
                            mb: 2,
                            mx: "auto",
                            position: "relative",
                        }}>
                        <Box
                            sx={{
                                width: 250,
                                height: 250,
                                mb: 2,
                                mx: "auto",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: "#fff",
                                borderRadius: 2,
                                p: 2,
                            }}>
                            <QRCode
                                id="qr-code"
                                value={shareLink}
                                size={200}
                                bgColor="#ffffff"
                                fgColor="#000000"
                                level="Q"
                            />
                        </Box>

                        <Tooltip title="Download QR" arrow>
                            <IconButton
                                size="small"
                                sx={{
                                    position: "absolute",
                                    top: -10,
                                    right: -10,
                                    background: "rgba(255,255,255,0.9)",
                                    "&:hover": {
                                        background: "rgba(255,255,255,1)",
                                    },
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                                }}
                                onClick={downloadQR}>
                                <FaDownload size={14} />
                            </IconButton>
                        </Tooltip>
                    </Box>

                    <Box sx={{ display: "flex", gap: 2, mb: 1 }}>
                        <Tooltip
                            title={copied ? "Copied!" : "Copy Linked"}
                            arrow>
                            <IconButton
                                sx={{
                                    background: "#d7d7d7",
                                    "&:hover": { background: "#d5d5d5" },
                                }}
                                onClick={handleCopy}>
                                {copied ? <FaCheck /> : <FaRegCopy />}
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Share on WhatsApp" arrow>
                            <IconButton
                                sx={{
                                    background: "#25D366",
                                    "&:hover": { background: "#1DA851" },
                                    color: "#fff",
                                }}
                                onClick={() => handleShare("whatsapp")}>
                                <FaWhatsapp />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Share on Facebook" arrow>
                            <IconButton
                                sx={{
                                    background: "#4267B2",
                                    "&:hover": { background: "#334d9e" },
                                    color: "#fff",
                                }}
                                onClick={() => handleShare("facebook")}>
                                <FaFacebookF />
                            </IconButton>
                        </Tooltip>
                    </Box>

                    <ShareLinkRow shareLink={shareLink} />
                </Box>
            </Fade>
        </Modal>
    );
}
